import { Box } from "@mui/material";
import { TEXT_SUBTLE } from "./bentoTokens";

// Centered gray empty-state block, matching scenes/financial's inline empty states
// (e.g. OutstandingCard's "no data" row).
const EmptyState = ({ icon, message, sx }) => (
  <Box sx={{ p: 4, textAlign: "center", color: TEXT_SUBTLE, ...sx }}>
    {icon && <Box sx={{ mb: 1, display: "flex", justifyContent: "center" }}>{icon}</Box>}
    {message}
  </Box>
);

export default EmptyState;
